import { useMutation } from "@tanstack/react-query"
import { api } from "@/api/instance"
import { appPath } from "@/shared/lib/appPath"

function impersonateErrorMessage(err: unknown): string {
  const data = (
    err as {
      response?: { status?: number; data?: { error?: string; detail?: string } }
    }
  )?.response?.data
  const status = (err as { response?: { status?: number } })?.response?.status
  const message = data?.error || data?.detail
  if (status === 403) return message || "Недостаточно прав"
  if (status === 400) return message || "Некорректный email"
  return message || "Не удалось переключить аккаунт"
}

export function useImpersonate() {
  return useMutation({
    mutationFn: async (email: string) => {
      await api.instance.post("/auth/impersonate", { email })
    },
    onSuccess: () => {
      window.location.assign(appPath("/recsys"))
    },
    // Dialog maps status → message; suppress the global toast.
    onError: () => undefined,
  })
}

export { impersonateErrorMessage }
